import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-form__container"
}
const _hoisted_2 = {
  key: 0,
  class: "d-form__head"
}
const _hoisted_3 = { class: "d-form__title" }
const _hoisted_4 = { class: "d-form__edit" }
const _hoisted_5 = {
  key: 1,
  class: "d-form__head"
}
const _hoisted_6 = { class: "d-form__title" }
const _hoisted_7 = { class: "d-form__edit" }
const _hoisted_8 = { class: "d-form__fragment" }
const _hoisted_9 = {
  key: 0,
  class: "d-form__section"
}
const _hoisted_10 = { class: "d-form__section-head" }
const _hoisted_11 = { class: "d-form__field-container" }
const _hoisted_12 = {
  key: 0,
  class: "d-form__field-content--static"
}
const _hoisted_13 = {
  key: 0,
  class: "d-form__field-boolean"
}
const _hoisted_14 = { class: "d-form__field-label" }
const _hoisted_15 = {
  key: 1,
  class: "d-form__field-value"
}
const _hoisted_16 = {
  key: 1,
  class: "d-form__field-content"
}
const _hoisted_17 = {
  key: 1,
  class: "d-form__section"
}
const _hoisted_18 = { class: "d-form__field-container" }
const _hoisted_19 = {
  key: 0,
  class: "d-form__field-content--static"
}
const _hoisted_20 = {
  key: 0,
  class: "d-form__field-boolean"
}
const _hoisted_21 = { class: "d-form__field-label" }
const _hoisted_22 = {
  key: 1,
  class: "d-form__field-value"
}
const _hoisted_23 = {
  key: 1,
  class: "d-form__field-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return ($props.template?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!$setup.isEditing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h4", _hoisted_3, _toDisplayString($props.title), 1),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_btn, {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.isEditing = true), ["stop"])),
                  flat: "",
                  rounded: "",
                  color: "primary"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "t-icon uppercase" }, "P", -1),
                    _createElementVNode("span", null, "Edit", -1)
                  ])),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString($props.title), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_q_btn, {
                  class: "success",
                  onClick: _withModifiers($setup.confirm, ["stop"]),
                  flat: "",
                  rounded: ""
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("div", { class: "t-icon lowercase" }, "e", -1),
                    _createElementVNode("span", null, "Confirm", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_q_btn, {
                  class: "error",
                  onClick: _withModifiers($setup.reset, ["stop"]),
                  flat: "",
                  rounded: "",
                  color: "error"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("div", { class: "t-icon error lowercase" }, "j", -1),
                    _createElementVNode("span", null, "Cancel", -1)
                  ])),
                  _: 1
                })
              ])
            ])),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.template, (fragment) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (fragment.section)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("h5", _hoisted_10, _toDisplayString(fragment.label), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((fragment.fields || []), (field) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (!$setup.editing)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (field.type === $setup.DFormInputType.Checkbox)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("div", {
                                    class: "t-icon lowercase",
                                    style: _normalizeStyle({color: $setup.getField(field.field) ? 'var(--directr__success)' : 'var(--directr__error)'})
                                  }, _toDisplayString($setup.getField(field.field) ? 'e' : 'j'), 5)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(field.label || field.field), 1),
                            (field.type !== $setup.DFormInputType.Checkbox)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($setup.getField(field.field)), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (field.type === $setup.DFormInputType.Text)
                              ? (_openBlock(), _createBlock(_component_q_input, {
                                  key: 0,
                                  class: "d-form__field",
                                  unelevated: "",
                                  dense: "",
                                  rounded: "",
                                  outlined: "",
                                  clearable: "",
                                  counter: !!field.max,
                                  max: field.max,
                                  label: field.label || field.field,
                                  "model-value": $setup.getField(field.field),
                                  "onUpdate:modelValue": ($event: any) => ($setup.setField(field.field, $event))
                                }, null, 8, ["counter", "max", "label", "model-value", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (field.type === $setup.DFormInputType.Password)
                              ? (_openBlock(), _createBlock(_component_q_input, {
                                  key: 1,
                                  class: "d-form__field",
                                  unelevated: "",
                                  dense: "",
                                  rounded: "",
                                  outlined: "",
                                  clearable: "",
                                  counter: !!field.max,
                                  max: field.max,
                                  label: field.label || field.field,
                                  type: "password",
                                  "model-value": $setup.getField(field.field),
                                  "onUpdate:modelValue": ($event: any) => ($setup.setField(field.field, $event))
                                }, null, 8, ["counter", "max", "label", "model-value", "onUpdate:modelValue"]))
                              : (field.type === $setup.DFormInputType.Number)
                                ? (_openBlock(), _createBlock(_component_q_input, {
                                    key: 2,
                                    class: "d-form__field",
                                    unelevated: "",
                                    dense: "",
                                    rounded: "",
                                    outlined: "",
                                    clearable: "",
                                    counter: !!field.max,
                                    max: field.max,
                                    label: field.label || field.field,
                                    type: "number",
                                    "model-value": $setup.getField(field.field),
                                    "onUpdate:modelValue": ($event: any) => ($setup.setField(field.field, $event))
                                  }, null, 8, ["counter", "max", "label", "model-value", "onUpdate:modelValue"]))
                                : (field.type === $setup.DFormInputType.Select)
                                  ? (_openBlock(), _createBlock(_component_q_select, {
                                      key: 3,
                                      class: "d-form__field",
                                      unelevated: "",
                                      dense: "",
                                      rounded: "",
                                      outlined: "",
                                      clearable: "",
                                      counter: !!field.max,
                                      max: field.max,
                                      label: field.label || field.field,
                                      type: "select",
                                      "model-value": $setup.getField(field.field),
                                      "onUpdate:modelValue": ($event: any) => ($setup.setField(field.field, $event)),
                                      options: field.options
                                    }, null, 8, ["counter", "max", "label", "model-value", "onUpdate:modelValue", "options"]))
                                  : (field.type === $setup.DFormInputType.Checkbox)
                                    ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                        key: 4,
                                        class: "d-form__field",
                                        unelevated: "",
                                        dense: "",
                                        rounded: "",
                                        label: field.label || field.field,
                                        "model-value": $setup.getField(field.field) || false,
                                        "onUpdate:modelValue": ($event: any) => ($setup.setField(field.field, $event))
                                      }, null, 8, ["label", "model-value", "onUpdate:modelValue"]))
                                    : _createCommentVNode("", true)
                          ]))
                    ]))
                  }), 256))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (!$setup.editing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          (fragment.type === $setup.DFormInputType.Checkbox)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", {
                                  class: "t-icon lowercase",
                                  style: _normalizeStyle({color: $setup.getField(fragment.field) ? 'var(--directr__success)' : 'var(--directr__error)'})
                                }, _toDisplayString($setup.getField(fragment.field) ? 'e' : 'j'), 5)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(fragment.label || fragment.field), 1),
                          (fragment.type !== $setup.DFormInputType.Checkbox)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.getField(fragment.field)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (fragment.type === $setup.DFormInputType.Text)
                            ? (_openBlock(), _createBlock(_component_q_input, {
                                key: 0,
                                class: "d-form__field",
                                unelevated: "",
                                dense: "",
                                rounded: "",
                                outlined: "",
                                clearable: "",
                                counter: !!fragment.max,
                                max: fragment.max,
                                label: fragment.label || fragment.field,
                                "model-value": $setup.getField(fragment.field),
                                "onUpdate:modelValue": ($event: any) => ($setup.setField(fragment.field, $event))
                              }, null, 8, ["counter", "max", "label", "model-value", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          (fragment.type === $setup.DFormInputType.Password)
                            ? (_openBlock(), _createBlock(_component_q_input, {
                                key: 1,
                                class: "d-form__field",
                                unelevated: "",
                                dense: "",
                                rounded: "",
                                outlined: "",
                                clearable: "",
                                counter: !!fragment.max,
                                max: fragment.max,
                                label: fragment.label || fragment.field,
                                type: "password",
                                "model-value": $setup.getField(fragment.field),
                                "onUpdate:modelValue": ($event: any) => ($setup.setField(fragment.field, $event))
                              }, null, 8, ["counter", "max", "label", "model-value", "onUpdate:modelValue"]))
                            : (fragment.type === $setup.DFormInputType.Number)
                              ? (_openBlock(), _createBlock(_component_q_input, {
                                  key: 2,
                                  class: "d-form__field",
                                  unelevated: "",
                                  dense: "",
                                  rounded: "",
                                  outlined: "",
                                  clearable: "",
                                  counter: !!fragment.max,
                                  max: fragment.max,
                                  label: fragment.label || fragment.field,
                                  type: "number",
                                  "model-value": $setup.getField(fragment.field),
                                  "onUpdate:modelValue": ($event: any) => ($setup.setField(fragment.field, $event))
                                }, null, 8, ["counter", "max", "label", "model-value", "onUpdate:modelValue"]))
                              : (fragment.type === $setup.DFormInputType.Checkbox)
                                ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                    key: 3,
                                    class: "d-form__field",
                                    unelevated: "",
                                    dense: "",
                                    rounded: "",
                                    label: fragment.label || fragment.field,
                                    "model-value": $setup.getField(fragment.field) || false,
                                    "onUpdate:modelValue": ($event: any) => ($setup.setField(fragment.field, $event))
                                  }, null, 8, ["label", "model-value", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                        ]))
                  ])
                ]))
          ]))
        }), 256))
      ]))
    : _createCommentVNode("", true)
}